// extracted by mini-css-extract-plugin
module.exports = {"infoBoxReservation":"InfoBoxContainerReservation-Jtails_infoBoxReservation_1OLB7","ordersList":"InfoBoxContainerReservation-Jtails_ordersList_vizn1"};